export var ESiteType;
/** Утилита для отправки корректного page.siteType в аналитику */

(function (ESiteType) {
  ESiteType["desktop"] = "desktop";
  ESiteType["mobile"] = "mobile";
  ESiteType["tablet"] = "tablet";
})(ESiteType || (ESiteType = {}));

export function getSiteType(deviceType) {
  return deviceType === 'phone' ? ESiteType.mobile : ESiteType[deviceType];
}